document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.getElementById('mobile-menu');
  if (!drawer) return;

  var shopCategories = [
    { title: 'Wheel & Tailgate Bags', url: '/collections/4wd-wheel-tailgate-bags', image: 'https://cdn.shopify.com/s/files/1/0257/3464/3774/collections/Desktop_800x600.jpg?v=1783687227' },
    { title: '4WD Organisers', url: '/collections/4wd-organisers', image: 'https://cdn.shopify.com/s/files/1/0257/3464/3774/collections/851C18C7-C157-49CF-912B-BA0FC366CD3A_800x600.jpg?v=1783687634' },
    { title: 'Canvas Drawer Bags', url: '/collections/canvas-drawer-bags', image: 'https://cdn.shopify.com/s/files/1/0257/3464/3774/collections/blacksmith-camping-supplies-australian-made-clear-top-large-drawer-bag-28694688333886_800x600.jpg?v=1783769676' },
    { title: 'BBQ & Cooking Bags', url: '/collections/bbq-cooker-bags', image: 'https://cdn.shopify.com/s/files/1/0257/3464/3774/collections/bbq-bags_800x600.jpg?v=1783688242' },
    { title: 'Tool Rolls & Tool Bags', url: '/collections/canvas-tool-rolls-tool-bags', image: 'https://cdn.shopify.com/s/files/1/0257/3464/3774/collections/Seat-Organiser_cabc6eb8-243a-40f3-ae1f-f2839db14132_800x600.jpg?v=1783687431' },
    { title: 'Firewood Carriers', url: '/collections/firewood-carriers', image: 'https://cdn.shopify.com/s/files/1/0257/3464/3774/collections/0005_BLACKSMITHFWBAG-2_800x600.jpg?v=1783769337' }
  ];

  function updateAnnouncementHeight() {
    var announcement = document.querySelector('.announcement-bar-section');
    var height = announcement ? Math.ceil(announcement.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--bs-announcement-height', height + 'px');
  }

  updateAnnouncementHeight();
  window.addEventListener('resize', updateAnnouncementHeight, { passive: true });

  if (!document.getElementById('blacksmith-mobile-menu-layer-fix')) {
    var layerFix = document.createElement('style');
    layerFix.id = 'blacksmith-mobile-menu-layer-fix';
    layerFix.textContent =
      '@media only screen and (max-width:1067px){' +
      '.announcement-bar-section{position:relative!important;z-index:2147483002!important;}' +
      'body:has(#mobile-menu.active) .header-section{position:relative!important;z-index:2147483000!important;}' +
      '#mobile-menu.blacksmith-mobile-menu{' +
        '--bs-menu-accent:#43423f!important;' +
        'top:var(--bs-announcement-height,40px)!important;' +
        'bottom:0!important;' +
        'height:calc(100vh - var(--bs-announcement-height,40px))!important;' +
        'min-height:calc(100vh - var(--bs-announcement-height,40px))!important;' +
        'z-index:2147483001!important;' +
      '}' +
      '@supports(height:100dvh){#mobile-menu.blacksmith-mobile-menu{' +
        'height:calc(100dvh - var(--bs-announcement-height,40px))!important;' +
        'min-height:calc(100dvh - var(--bs-announcement-height,40px))!important;' +
      '}}' +
      '.mobile-toggle-wrapper.active>.mobile-toggle{' +
        'top:calc(var(--bs-announcement-height,40px) + env(safe-area-inset-top) + 14px)!important;' +
        'right:14px!important;left:auto!important;' +
        'width:48px!important;height:48px!important;display:flex!important;align-items:center!important;justify-content:center!important;' +
        'padding:0!important;z-index:2147483003!important;' +
      '}' +
      '.mobile-toggle-wrapper.active>.mobile-toggle svg{' +
        'width:22px!important;height:22px!important;margin:0!important;' +
      '}' +
      '.blacksmith-mobile-menu .link-forward{' +
        'width:auto!important;height:auto!important;min-width:0!important;' +
        'display:inline-flex!important;align-items:center!important;justify-content:center!important;' +
        'padding:0!important;border-radius:0!important;background:transparent!important;color:#fff!important;' +
        'font-size:0!important;' +
      '}' +
      '.blacksmith-mobile-menu .link-forward svg{display:none!important;}' +
      '.blacksmith-mobile-menu .link-forward:after{' +
        'content:">"!important;color:#fff!important;font-size:1.2rem!important;font-weight:600!important;line-height:1!important;' +
      '}' +
      '.blacksmith-mobile-menu .parent-link-back{' +
        'display:flex!important;align-items:center!important;min-height:48px!important;' +
        'margin:17px 0 14px!important;padding:0!important;border-bottom:0!important;' +
      '}' +
      '.blacksmith-mobile-menu .parent-link-back button{' +
        'display:inline-flex!important;align-items:center!important;gap:6px!important;' +
        'width:auto!important;height:auto!important;margin:0!important;padding:0!important;' +
        'border:0!important;border-radius:0!important;background:transparent!important;color:#fff!important;' +
        'font-size:.72rem!important;letter-spacing:.06em!important;' +
      '}' +
      '.blacksmith-mobile-menu .parent-link-back button span{' +
        'display:inline-flex!important;align-items:center!important;justify-content:center!important;' +
      '}' +
      '.blacksmith-mobile-menu .parent-link-back button svg{' +
        'width:14px!important;height:14px!important;' +
      '}' +
      '.blacksmith-mobile-menu .parent-link-back button svg path{' +
        'stroke:#fff!important;' +
      '}' +
      '.blacksmith-mobile-menu__promo-copy{' +
        'align-items:baseline!important;justify-content:flex-start!important;gap:7px!important;' +
      '}' +
      '.blacksmith-mobile-menu__promo-arrow{' +
        'width:auto!important;height:auto!important;display:inline-flex!important;align-items:center!important;' +
        'justify-content:center!important;border-radius:0!important;background:transparent!important;color:#fff!important;' +
        'font-size:0!important;line-height:1!important;' +
      '}' +
      '.blacksmith-mobile-menu__promo-arrow:after{' +
        'content:">"!important;color:#fff!important;font-size:1rem!important;font-weight:600!important;line-height:1!important;' +
      '}' +
      '.blacksmith-mobile-menu__shop-panel>li:not(.parent-link-back):not(.blacksmith-mobile-menu__shop-grid-item){display:none!important;}' +
      '.blacksmith-mobile-menu__shop-grid-item{display:block!important;margin:0!important;padding:0!important;}' +
      '.blacksmith-mobile-menu__shop-grid{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;' +
        'gap:10px!important;padding:0 0 14px!important;}' +
      '.blacksmith-mobile-menu__shop-card{' +
        'position:relative!important;display:block!important;min-height:132px!important;overflow:hidden!important;' +
        'border-radius:10px!important;background-color:#27292a!important;background-position:center!important;' +
        'background-size:cover!important;color:#fff!important;isolation:isolate!important;' +
      '}' +
      '.blacksmith-mobile-menu__shop-card:after{' +
        'content:""!important;position:absolute!important;inset:0!important;z-index:-1!important;' +
        'background:linear-gradient(to top,rgba(0,0,0,.72),rgba(0,0,0,.05) 72%)!important;' +
      '}' +
      '.blacksmith-mobile-menu__shop-card-copy{' +
        'position:absolute!important;right:11px!important;bottom:11px!important;left:11px!important;' +
        'display:flex!important;align-items:baseline!important;justify-content:flex-start!important;gap:7px!important;' +
      '}' +
      '.blacksmith-mobile-menu__shop-card-title{' +
        'max-width:calc(100% - 24px)!important;color:#fff!important;font-size:.9rem!important;' +
        'font-weight:var(--font-body-bold-weight,600)!important;line-height:1.12!important;' +
      '}' +
      '.blacksmith-mobile-menu__shop-card-arrow{' +
        'flex:0 0 auto!important;color:#fff!important;font-size:.9rem!important;font-weight:600!important;line-height:1!important;' +
      '}' +
      '.blacksmith-mobile-menu__shop-all{' +
        'display:flex!important;align-items:center!important;justify-content:center!important;width:100%!important;' +
        'min-height:48px!important;margin:0 0 24px!important;padding:0 18px!important;' +
        'border:1px solid #43423f!important;border-radius:8px!important;background:#f7f7f7!important;color:#43423f!important;' +
        'font-size:.82rem!important;font-weight:var(--font-body-bold-weight,600)!important;letter-spacing:.04em!important;text-transform:uppercase!important;' +
      '}' +
      '@media only screen and (max-width:380px){' +
        '.blacksmith-mobile-menu__shop-grid{gap:8px!important;}' +
        '.blacksmith-mobile-menu__shop-card{min-height:118px!important;}' +
        '.blacksmith-mobile-menu__shop-card-title,.blacksmith-mobile-menu__shop-card-arrow{font-size:.82rem!important;}' +
      '}' +
      '}';
    document.head.appendChild(layerFix);
  }

  var inner = drawer.querySelector('.mobile-menu-drawer--inner');
  var primaryMenu = drawer.querySelector('.mobile-menu');
  if (!inner || !primaryMenu) return;

  function directChildWithClass(parent, className) {
    if (!parent) return null;
    for (var i = 0; i < parent.children.length; i += 1) {
      if (parent.children[i].classList.contains(className)) return parent.children[i];
    }
    return null;
  }

  function buildShopGrid() {
    var shopItem = null;

    for (var i = 0; i < primaryMenu.children.length; i += 1) {
      var item = primaryMenu.children[i];
      var details = directChildWithClass(item, 'link-container');
      if (!details || details.tagName !== 'DETAILS') continue;

      var summary = directChildWithClass(details, 'parent-link');
      var label = summary ? summary.textContent.replace(/\s+/g, ' ').trim() : '';

      if (label === 'Shop') {
        shopItem = item;
        break;
      }
    }

    if (!shopItem) return;

    var shopDetails = directChildWithClass(shopItem, 'link-container');
    var shopPanel = directChildWithClass(shopDetails, 'sub-menu');
    if (!shopPanel || shopPanel.querySelector('.blacksmith-mobile-menu__shop-grid')) return;

    shopPanel.classList.add('blacksmith-mobile-menu__shop-panel');

    var gridItem = document.createElement('li');
    gridItem.className = 'blacksmith-mobile-menu__shop-grid-item';

    var grid = document.createElement('div');
    grid.className = 'blacksmith-mobile-menu__shop-grid';
    grid.setAttribute('aria-label', 'Shop categories');

    shopCategories.forEach(function (category) {
      var card = document.createElement('a');
      card.className = 'blacksmith-mobile-menu__shop-card';
      card.href = category.url;
      card.style.backgroundImage = 'url("' + category.image + '")';
      card.innerHTML =
        '<span class="blacksmith-mobile-menu__shop-card-copy">' +
          '<strong class="blacksmith-mobile-menu__shop-card-title">' + category.title + '</strong>' +
          '<span class="blacksmith-mobile-menu__shop-card-arrow" aria-hidden="true">&gt;</span>' +
        '</span>';
      grid.appendChild(card);
    });

    var shopAll = document.createElement('a');
    shopAll.className = 'blacksmith-mobile-menu__shop-all';
    shopAll.href = '/collections/shop-all';
    shopAll.textContent = 'Shop all';

    gridItem.appendChild(grid);
    gridItem.appendChild(shopAll);

    var backItem = directChildWithClass(shopPanel, 'parent-link-back');
    if (backItem && backItem.nextSibling) {
      shopPanel.insertBefore(gridItem, backItem.nextSibling);
    } else {
      shopPanel.appendChild(gridItem);
    }
  }

  if (!primaryMenu.querySelector('[data-blacksmith-about-us]')) {
    var aboutItem = document.createElement('li');
    aboutItem.setAttribute('data-blacksmith-about-us', '');
    aboutItem.innerHTML = '<a class="link-container" href="/pages/about-us">About Us</a>';
    primaryMenu.appendChild(aboutItem);
  }

  var utilityLinks = drawer.querySelector('.blacksmith-mobile-menu__utilities');
  if (!utilityLinks) {
    utilityLinks = document.createElement('nav');
    utilityLinks.className = 'blacksmith-mobile-menu__utilities';
    utilityLinks.setAttribute('aria-label', 'Utility navigation');
    utilityLinks.innerHTML =
      '<a href="/search">Search</a>' +
      '<a href="/pages/faqs">FAQs</a>' +
      '<a href="/pages/contact-us">Contact</a>' +
      '<a href="/account">Account</a>';
  }

  primaryMenu.insertAdjacentElement('afterend', utilityLinks);

  var origins = drawer.querySelectorAll('.blacksmith-mobile-menu__origin');
  var origin = origins.length ? origins[0] : document.createElement('p');
  origin.className = 'blacksmith-mobile-menu__origin';
  origin.textContent = 'Made in South Australia';
  utilityLinks.insertAdjacentElement('afterend', origin);

  for (var j = 1; j < origins.length; j += 1) origins[j].remove();

  buildShopGrid();

  var observer = new MutationObserver(function () {
    buildShopGrid();
  });

  observer.observe(drawer, { childList: true, subtree: true });
});
